import roles from '@/app/cashflow/roles.js'
import pageDefinition from '@/app/shared/pageDefinition'

export default class pages {
  bsgMenu = null;
  cashFlowMenu = null;
  templateMenu = null;
  elementYearlyPriceTemplates = null;
  yearlyFxRateTemplates = null;
  yearlyInflationRateTemplates = null;

  constructor() {
    this.bsgMenu = new pageDefinition("/bsg", "BSG", roles.readers, "DollarSignIcon", "BSG.Title", "BSG", true, () => import("@/app/bsg/index.vue"));
    this.bsgMenu.addSelfToBreadcrumb();

    this.cashFlowMenu = new pageDefinition("/bsg/cashflow", "BSG-CashFlow", roles.readers, "DollarSignIcon", "CashFlow.Title", "Cashflow", true, () => import("@/app/cashflow/Cashflow.vue"));
    this.cashFlowMenu.addItemToBreadcrumb(this.bsgMenu.toBreadcrumb(false));
    this.cashFlowMenu.addSelfToBreadcrumb();

    this.templateMenu = new pageDefinition("/bsg/cashflow/templates", "BSG-CashFlow-Templates", roles.writers, "LayersIcon", "CashFlow.Template.Title", "Templates", true, () => import("@/app/cashflow/templates/index.vue"));
    this.templateMenu.addItemToBreadcrumb(this.bsgMenu.toBreadcrumb(false));
    this.templateMenu.addItemToBreadcrumb(this.cashFlowMenu.toBreadcrumb(false));
    this.templateMenu.addSelfToBreadcrumb();

    this.elementYearlyPriceTemplates = new pageDefinition("/bsg/cashflow/templates/elementYearlyPriceTemplates", "BSG-CashFlow-Templates-ElementYearlyPriceTemplates", roles.writers, "DollarSignIcon", "CashFlow.ElementYearlyPriceTemplate.Title", "ElementYearlyPriceTemplates", true, () => import("@/app/cashflow/templates/elementYearlyPriceTemplates/index.vue"), "editor");
    this.elementYearlyPriceTemplates.addItemToBreadcrumb(this.bsgMenu.toBreadcrumb(false));
    this.elementYearlyPriceTemplates.addItemToBreadcrumb(this.cashFlowMenu.toBreadcrumb(false));
    this.elementYearlyPriceTemplates.addItemToBreadcrumb(this.templateMenu.toBreadcrumb(false));
    this.elementYearlyPriceTemplates.addSelfToBreadcrumb();

    this.elementYearlyPriceTemplatesEdit = new pageDefinition("/bsg/cashflow/templates/elementYearlyPriceTemplates/Edit", "BSG-CashFlow-Templates-ElementYearlyPriceTemplates-Edit", roles.writers, "DollarSignIcon", "CashFlow.ElementYearlyPriceTemplate.Edit", "ElementYearlyPriceTemplatesEdit", true, () => import("@/app/cashflow/templates/elementYearlyPriceTemplates/edit.vue"), "editor");
    this.elementYearlyPriceTemplatesEdit.addItemToBreadcrumb(this.bsgMenu.toBreadcrumb(false));
    this.elementYearlyPriceTemplatesEdit.addItemToBreadcrumb(this.cashFlowMenu.toBreadcrumb(false));
    this.elementYearlyPriceTemplatesEdit.addItemToBreadcrumb(this.templateMenu.toBreadcrumb(false));
    this.elementYearlyPriceTemplatesEdit.addItemToBreadcrumb(this.elementYearlyPriceTemplates.toBreadcrumb(false));
    this.elementYearlyPriceTemplatesEdit.addSelfToBreadcrumb();

    this.yearlyFxRateTemplates = new pageDefinition("/bsg/cashflow/templates/yearlyFxRateTemplates", "BSG-CashFlow-Templates-YearlyFxRateTemplates", roles.writers, "GlobeIcon", "CashFlow.YearlyFxRateTemplate.Title", "YearlyFxRateTemplate", true, () => import("@/app/cashflow/templates/yearlyFxRateTemplates/index.vue"), "editor");
    this.yearlyFxRateTemplates.addItemToBreadcrumb(this.bsgMenu.toBreadcrumb(false));
    this.yearlyFxRateTemplates.addItemToBreadcrumb(this.cashFlowMenu.toBreadcrumb(false));
    this.yearlyFxRateTemplates.addItemToBreadcrumb(this.templateMenu.toBreadcrumb(false));
    this.yearlyFxRateTemplates.addSelfToBreadcrumb();

    this.yearlyFxRateTemplatesEdit = new pageDefinition("/bsg/cashflow/templates/yearlyFxRateTemplates/Edit", "BSG-CashFlow-Templates-YearlyFxRateTemplates-Edit", roles.writers, "GlobeIcon", "CashFlow.YearlyFxRateTemplate.Edit", "YearlyFxRateTemplateEdit", true, () => import("@/app/cashflow/templates/yearlyFxRateTemplates/edit.vue"), "editor");
    this.yearlyFxRateTemplatesEdit.addItemToBreadcrumb(this.bsgMenu.toBreadcrumb(false));
    this.yearlyFxRateTemplatesEdit.addItemToBreadcrumb(this.cashFlowMenu.toBreadcrumb(false));
    this.yearlyFxRateTemplatesEdit.addItemToBreadcrumb(this.templateMenu.toBreadcrumb(false));
    this.yearlyFxRateTemplatesEdit.addItemToBreadcrumb(this.yearlyFxRateTemplates.toBreadcrumb(false));
    this.yearlyFxRateTemplatesEdit.addSelfToBreadcrumb();

    this.yearlyInflationRateTemplates = new pageDefinition("/bsg/cashflow/templates/yearlyInflationRateTemplates", "BSG-CashFlow-Templates-YearlyInflationRateTemplates", roles.writers, "CornerRightUpIcon", "CashFlow.YearlyInflationRateTemplate.Title", "YearlyInflationRateTemplates", true, () => import("@/app/cashflow/templates/yearlyInflationRateTemplates/index.vue"), "editor");
    this.yearlyInflationRateTemplates.addItemToBreadcrumb(this.bsgMenu.toBreadcrumb(false));
    this.yearlyInflationRateTemplates.addItemToBreadcrumb(this.cashFlowMenu.toBreadcrumb(false));
    this.yearlyInflationRateTemplates.addItemToBreadcrumb(this.templateMenu.toBreadcrumb(false));
    this.yearlyInflationRateTemplates.addSelfToBreadcrumb();

    this.yearlyInflationRateTemplatesEdit = new pageDefinition("/bsg/cashflow/templates/yearlyInflationRateTemplates/Edit", "BSG-CashFlow-Templates-YearlyInflationRateTemplates-Edit", roles.writers, "GlobeIcon", "CashFlow.YearlyInflationRateTemplate.Edit", "YearlyInflationRateTemplatesEdit", true, () => import("@/app/cashflow/templates/yearlyInflationRateTemplates/edit.vue"), "editor");
    this.yearlyInflationRateTemplatesEdit.addItemToBreadcrumb(this.bsgMenu.toBreadcrumb(false));
    this.yearlyInflationRateTemplatesEdit.addItemToBreadcrumb(this.cashFlowMenu.toBreadcrumb(false));
    this.yearlyInflationRateTemplatesEdit.addItemToBreadcrumb(this.templateMenu.toBreadcrumb(false));
    this.yearlyInflationRateTemplatesEdit.addItemToBreadcrumb(this.yearlyInflationRateTemplates.toBreadcrumb(false));
    this.yearlyInflationRateTemplatesEdit.addSelfToBreadcrumb();
  }

  getTemplateItems() {
    const items = [];
    return items;
  }

  getRoutes() {
    const items = [];
    items.push(this.templateMenu.toRoute());
    items.push(this.elementYearlyPriceTemplates.toRoute());
    items.push(this.yearlyFxRateTemplates.toRoute());
    items.push(this.yearlyInflationRateTemplates.toRoute());
    return items;
  }
}
